import axios from 'axios';
import { isAfter, subMinutes } from 'date-fns';
import type { GetTokenResponseDTO } from '~/dto/Assegurou/getToken';
import Env from '~/env';
import { LocalStorage } from '~/storage/LocalStorage';
import { INSURANCE_AUTH_KEY } from '~/storage/constants';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

type InsuranceAutoAuth = {
  token: string;
  tokenExpire: string;
};
const ASSEGUROU_URL = Env.INSURANCE_URL;

export async function getAssegurouTokenUseCase() {
  try {
    const [ASSEGUROU_USER, ASSEGUROU_PASS] =
      MarisaAppUtils.getOriginInsuranceApi();
    const insuranceAuth: InsuranceAutoAuth | undefined = await LocalStorage.get(
      INSURANCE_AUTH_KEY
    );

    if (insuranceAuth) {
      // 10 minutes before the token expires
      const expiresInDate = subMinutes(
        new Date(insuranceAuth?.tokenExpire),
        10
      );

      if (isAfter(expiresInDate, new Date())) {
        return insuranceAuth?.token;
      }
    }

    const response = await axios.post<GetTokenResponseDTO>(
      `${ASSEGUROU_URL}/v1/Autenticacao/Autenticar`,
      {
        UserName: ASSEGUROU_USER,
        PassWord: ASSEGUROU_PASS,
      }
    );

    if (response.status !== 200) {
      throw new Error('Erro ao obter token');
    }

    LocalStorage.set(INSURANCE_AUTH_KEY, {
      token: response.data.resultData.token.token,
      tokenExpire: response.data.resultData.token.tokenExpire,
    });

    return response.data.resultData.token.token;
  } catch (error) {
    console.log('get_assegurou_auto_token', error);
    return null;
  }
}
